import * as Helper from "./Helper";
import EmojiData from './emoji.json';

class EmojiManager {
    constructor() {
        this._charMap = new Map();
    }

    getImage(c) {
        const code = this._charMap.get(c);
        if (code) {
            return Helper.convertToFileServerPath(`~/fs/images/emoji/${code}.png`);
        }
        return null;
    }

    loadData(data) {
        this._charMap.clear();
        const count = data.length;
        for (let i = 0; i < count; ++i) {
            let it = data[i];
            this._charMap.set(it[0], it[1]);
        }
    }
}

var g_emojiManager = new EmojiManager();
g_emojiManager.loadData(EmojiData);

export default g_emojiManager;
